import { useMemo } from "react";
import AutocompleteField from "./AutocompleteField";
import { useAdvertiserContentLanguage } from "../../hooks/useAdvertiserContentLanguage";
import { getContentLanguageOptions } from "../../utils/catalogs/contentLanguage";

const SelectContentLanguage = ({
  name = "language",
  control,
  errors = {},
  preset,
  label = "",
  placeholder = "",
  variant = "filled",
  size = "medium",
  disabled = false,
  persistOnChange = false,
  rules = {},
  fullWidth = true,
  disableClearable = true,
  doTranslate = true,
  sx = {},
}) => {
  const { onPersistLanguage } = useAdvertiserContentLanguage();
  const options = useMemo(
    () => getContentLanguageOptions({ preset }),
    [preset]
  );

  return (
    <AutocompleteField
      name={name}
      control={control}
      errors={errors}
      options={options}
      label={label}
      placeholder={placeholder}
      variant={variant}
      size={size}
      disabled={disabled}
      rules={rules}
      fullWidth={fullWidth}
      disableClearable={disableClearable}
      doTranslate={doTranslate}
      sx={sx}
      onValueChange={persistOnChange ? onPersistLanguage : undefined}
    />
  );
};

export default SelectContentLanguage;
